import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/unit_sizes";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/UnitSize?status=1";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
   

}
